import { Flex, FlexProps, Image, ImageProps, Text, TextProps } from 'components'

export interface Props extends Omit<FlexProps, 'children'> {
  button?: JSX.Element
  description?: string
  iconSrc?: string
  iconProps?: ImageProps
  textProps?: TextProps
  title: string
}

export default function EmptyState({
  button,
  description,
  iconSrc,
  iconProps,
  textProps,
  title,
  ...rest
}: Props) {
  return (
    <Flex align="center" direction="column" gap={3} {...rest}>
      <Image src={iconSrc} height="50px" {...iconProps} />
      <Text textStyle="h4" textAlign="center" {...textProps}>
        {title}
      </Text>
      {description && (
        <Text
          textStyle="bodyMedium"
          opacity={0.6}
          textAlign="center"
          fontWeight="normal"
          {...textProps}
        >
          {description}
        </Text>
      )}
      {button}
    </Flex>
  )
}
